<template>
    <div>
        <b-row>
            <b-col sm="12">
                <b-card no-body>
                    <b-card-body>
                        <h4 class="heading-1 mb-4">
                            <span>ANEXOS</span>
                        </h4>
                        <app-tabela
                            :itens="consultoria.anexos"
                            :campos="campos"
                            :itensPorPagina="itensPorPagina"
                        >
                            <template slot="botoes">
                                <b-button-group class="float-right">
                                    <b-button
                                        variant="success"
                                        @click.stop="inserirAnexo()"
                                        v-if="mostrarBtnInserirAnexo"
                                        >Inserir Anexo</b-button
                                    >
                                </b-button-group>
                                <slot name="botoes"></slot>
                            </template>
                            <template slot="acoes" slot-scope="data">
                                <consultoria-anexo-download
                                    :consultoriaAnexo="data"
                                    :servicos="servicos"
                                ></consultoria-anexo-download>
                                <consultoria-anexo-excluir
                                    :consultoria="consultoria"
                                    :consultoriaAnexo="data"
                                    :servicos="servicos"
                                    @obterConsultoriaAtualizada="
                                        obterConsultoriaAtualizada()
                                    "
                                ></consultoria-anexo-excluir>
                                <slot name="acoes" v-bind="data"></slot>
                            </template>
                        </app-tabela>
                    </b-card-body>
                </b-card>
            </b-col>
        </b-row>
        <consultoria-anexo-form
            ref="anexoForm"
            @obterConsultoriaAtualizada="obterConsultoriaAtualizada()"
            :consultoria="consultoria"
            :servicos="servicos"
        ></consultoria-anexo-form>
    </div>
</template>

<script>
import ConsultoriaAnexoDownload from './ConsultoriaAnexoDownload'
import ConsultoriaAnexoForm from './ConsultoriaAnexoForm'
import ConsultoriaAnexoExcluir from './ConsultoriaAnexosExcluir'
import { consultoriaStatus } from '../../ConsultoriaStatus'

export default {
    props: {
        consultoria: {
            type: Object,
            default: () => ({})
        },

        servicos: {
            type: Object,
            required: true,
            default: () => ({})
        }
    },

    data() {
        return {
            campos: [
                {
                    key: 'tipoDescr',
                    label: 'Tipo',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'descritivo',
                    label: 'Descritivo',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'nomeArquivoOriginal',
                    label: 'Arquivo'
                },
                {
                    key: 'dataAtualizacao',
                    label: 'Atualizado em',
                    type: 'datetime'
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            itensPorPagina: 0
        }
    },

    methods: {
        obterConsultoriaAtualizada() {
            this.$emit('obterConsultoriaAtualizada')
        },

        inserirAnexo() {
            this.$refs.anexoForm.mostrarModal = true
        }
    },

    computed: {
        mostrarBtnInserirAnexo() {
            return (
                this.$temAcesso('APPSE-FORN-CONS-02') &&
                (this.consultoria.status === consultoriaStatus.EM_ANDAMENTO ||
                    this.consultoria.status ===
                        consultoriaStatus.CONCLUIDA_PENDENTE_ANALISE ||
                    this.consultoria.status ===
                        consultoriaStatus.CONCLUIDA_PENDENTE_CORRECAO)
            )
        }
    },

    components: {
        ConsultoriaAnexoDownload,
        ConsultoriaAnexoForm,
        ConsultoriaAnexoExcluir
    }
}
</script>
